import React from 'react'

const Introduction = () => {
    return (
        <div>
            <h1>Introduction</h1>
            <div className='leftdiv'>
                <img src='https://www.verywellmind.com/thmb/xEUj-cg1rVE5JI4fSvUNyAFynU8=/3000x0/filters:no_upscale():max_bytes(150000):strip_icc()/how-sleep-affects-mental-health-4783067_V2-2ce9483affb34f50bf7406c013767f11.gif' alt='into-img1' />
                <p>
                    Sleep is a fundamental aspect of our overall well-being and plays a crucial role in maintaining good mental health. Adequate and restful 
                    sleep is essential for cognitive function, emotional balance, and physical health.
                </p>
            </div>
            <div className='rightdiv'>
                <p> 
                    Unfortunately, many individuals struggle with sleep-related issues, which can negatively impact their mental well-being. Sleep problems, 
                    such as insomnia, sleep apnea, or restless leg syndrome, can disrupt sleep quality and quantity, leading to daytime fatigue, difficulty 
                    concentrating, mood disturbances, and reduced productivity.
                </p>
                <img src='https://mpowerminds.com/assetOLD/images/sleep-disorder.jpg' alt='intro-img2' />
            </div>
            <div className='leftdiv'>
                <img src='https://static.bangkokpost.com/media/content/20230102/c1_2473387_230102090439.jpg' alt='intro-img3' />
                <p>
                    In this section of our website, we aim to provide you with valuable insights into sleep, its importance for mental health, and strategies 
                    to optimize your sleep routine. Whether you're seeking information on improving sleep quality or managing specific sleep disorders, 
                    we're here to help.
                </p>
            </div>
            <div className='rightdiv'>
                <p>
                    We'll explore the science of sleep, discuss common sleep disorders, offer practical tips for better sleep hygiene, and provide resources 
                    to further support your sleep-related concerns. Our goal is to empower you with knowledge and strategies to prioritize and enhance your 
                    sleep, ultimately promoting your overall mental well-being.
                </p>
                <img src='https://medlux.net.ua/wp-content/uploads/2022/06/rasstrojstvo-sna-1.jpg' alt='intro-img4' />
            </div>
        </div>
    )
}

export default Introduction